import ApiService from 'services/ApiService/ApiService';

import coreService from './core';


export async function fetchFanClubs(options = {}) {
  const { genders, subscribedOnly, page, size, sortBy, direction } = options;

  const url = coreService.computeURL('models');
  url.searchParams.set('subscribedOnly', Boolean(subscribedOnly));
  url.searchParams.set('page', page || 0);
  url.searchParams.set('size', size || 10);

  if (sortBy) {
    url.searchParams.set('sortBy', sortBy);
  }

  if (direction) {
    url.searchParams.set('direction', direction);
  }

  genders?.map((gender) => url.searchParams.append('genders', gender));

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchFanClub({ username }) {
  const url = coreService.computeURL(`modelsByPartnerIdentifier/${username}/profileDetails`);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchMediaItems({ username, page, size }) {
  const url = coreService.computeURL(`models/${username}/freeForFansMediaContent`);
  url.searchParams.set('page', page || 0);
  url.searchParams.set('size', size || 10);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchMediaVideo({ modelDisplayName, contentId }) {
  const url = coreService.computeURL(`models/${modelDisplayName}/freeForFansVideos/${contentId}`);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchMediaGallery({ modelDisplayName, contentId }) {
  const url = coreService.computeURL(`models/${modelDisplayName}/freeForFansGalleries/${contentId}`);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchStoreItems({ username, page, size }) {
  const url = coreService.computeURL(`models/${username}/storeMediaContent/notPurchasedItems`);
  url.searchParams.set('page', page || 0);
  url.searchParams.set('size', size || 10);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchPurchasedItems() {
  const url = coreService.computeURL('models/storeMediaContent/purchasedItems');

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchPurchasedItemsByModel({ username, page, size }) {
  const url = coreService.computeURL(`models/${username}/storeMediaContent/purchasedItems`);
  url.searchParams.set('page', page || 0);
  url.searchParams.set('size', size || 10);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { isPerformer } = await coreService.getUser();
  if (isPerformer) {
    return null;
  }

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchPurchasedVideo({ modelDisplayName, contentId }) {
  const url = coreService.computeURL(`models/${modelDisplayName}/storeMediaContent/purchasedVideos/${contentId}`);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchPurchasedGallery({ modelDisplayName, contentId }) {
  const url = coreService.computeURL(`models/${modelDisplayName}/storeMediaContent/purchasedGalleries/${contentId}`);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchSharedFreeItem({ modelDisplayName, contentType, contentId }) {
  const url = coreService.computeURL(
    `models/${modelDisplayName}/freeForFansContent/${contentType}/${contentId}/details`
  );

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}

export async function fetchSharedStoreItem({ modelDisplayName, contentType, contentId }) {
  const url = coreService.computeURL(
    `models/${modelDisplayName}/storeMediaContent/${contentType}/${contentId}/details`
  );

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  const { data } = await ApiService.get(url.toString(), { headers });

  return data;
}
